import { render, staticRenderFns } from "./editAffiliateProduct.vue?vue&type=template&id=a166dda8"
import script from "./editAffiliateProduct.vue?vue&type=script&lang=js"
export * from "./editAffiliateProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports